// SPDX-License-Identifier: AGPL-3.0-only
import { Component } from 'react';
/**
 * Error boundary around the lazy widget component (loaded state). A
 * throwing widget — including a crashing marketplace code widget —
 * degrades to the frame's error state and never breaks sibling widgets.
 */
export class WidgetErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error: error instanceof Error ? error : new Error(String(error)) };
    }
    componentDidCatch(error, info) {
        this.props.onError?.(error, info);
    }
    reset = () => {
        this.setState({ error: null });
    };
    render() {
        if (this.state.error !== null)
            return this.props.fallback(this.state.error, this.reset);
        return this.props.children;
    }
}
//# sourceMappingURL=WidgetErrorBoundary.js.map